import React, { memo, useMemo } from "react";
import { Button as AntdButton } from "antd";
import { Link } from "umi";
import { Link as LinkIcon } from "../Icons";

const LinkButton = memo(({ to, onClick, underlined, children }) => {
  const Wrapper = useMemo(() => {
    if (typeof to === "string") {
      return Link;
    }

    return (...props) => <div {...props} />;
  }, [to]);

  return (
    <Wrapper to={to}>
      <AntdButton type="link" onClick={onClick}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ paddingRight: "4px" }}>
            <LinkIcon />
          </span>
          <span style={{ textDecoration: underlined ? "underline" : "auto" }}>{children}</span>
        </div>
      </AntdButton>
    </Wrapper>
  );
});

LinkButton.defaultProps = {
  underlined: true,
};

export default LinkButton;
